
import ppeFullLogo from '../ressources/logo-with-text-green.svg';
import React, { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';

const copingSelfRows = [
  {
    strategy: "SCOPE_REPORT_COPING_SELF_MODIFICATION",
    explanation: "SCOPE_REPORT_COPING_SELF_MODIFICATION_DESC",
    strengths: "SCOPE_REPORT_COPING_SELF_MODIFICATION_STRENGTHS",
    limits: "SCOPE_REPORT_COPING_SELF_MODIFICATION_LIMITS",
    noteIndex: 0,
  },
  {
    strategy: "SCOPE_REPORT_COPING_INTERNAL_ATTRIBUTION",
    explanation: "SCOPE_REPORT_COPING_INTERNAL_ATTRIBUTION_DESC",
    strengths: "SCOPE_REPORT_COPING_INTERNAL_ATTRIBUTION_STRENGTHS",
    limits: "SCOPE_REPORT_COPING_INTERNAL_ATTRIBUTION_LIMITS",
    noteIndex: 5,
  },
  {
    strategy: "SCOPE_REPORT_COPING_SELF_BOLSTERING",
    explanation: "SCOPE_REPORT_COPING_SELF_BOLSTERING_DESC",
    strengths: "SCOPE_REPORT_COPING_SELF_BOLSTERING_STRENGTHS",
    limits: "SCOPE_REPORT_COPING_SELF_BOLSTERING_LIMITS",
    noteIndex: 8,
  },
];

const copingCognitiveRows = [
  {
    strategy: "SCOPE_REPORT_COPING_PROBLEM_SOLVING",
    explanation: "SCOPE_REPORT_COPING_PROBLEM_SOLVING_DESC",
    strengths: "SCOPE_REPORT_COPING_PROBLEM_SOLVING_STRENGTHS",
    limits: "SCOPE_REPORT_COPING_PROBLEM_SOLVING_LIMITS",
    noteIndex: 1,
  },
  {
    strategy: "SCOPE_REPORT_COPING_RUMINATION",
    explanation: "SCOPE_REPORT_COPING_RUMINATION_DESC",
    strengths: "SCOPE_REPORT_COPING_RUMINATION_STRENGTHS",
    limits: "SCOPE_REPORT_COPING_RUMINATION_LIMITS",
    noteIndex: 4,
  },
  {
    strategy: "SCOPE_REPORT_COPING_WISHFUL_THINKING",
    explanation: "SCOPE_REPORT_COPING_WISHFUL_THINKING_DESC",
    strengths: "SCOPE_REPORT_COPING_WISHFUL_THINKING_STRENGTHS",
    limits: "SCOPE_REPORT_COPING_WISHFUL_THINKING_LIMITS",
    noteIndex: 7,
  },
];

export default function CopingDefinitionsPages({
  graph,
  code,
  datePassed,
  keyPage,
  getThirdPosition,
  SafeFormattedMessage,
}) {
  // Use destructuring to get locale from LanguageContext, fallback to graph.language
  const languageCtx = useContext(LanguageContext);
  const locale = (languageCtx && languageCtx.locale) ? languageCtx.locale : (graph.language ? graph.language : '');
  const isFrench = locale && typeof locale === 'string' && locale.toLowerCase().startsWith('fr');
  const isEnglish = locale && typeof locale === 'string' && locale.toLowerCase().startsWith('en');
 
  return (
    <div>
      <div className="PageCharts-chart">
        <div className="header-logo-box">
          <img alt="ppe-logo" className="header-logo-img" src={ppeFullLogo} />
        </div>
        <div className="report-alt-page">
          <h1>
            <SafeFormattedMessage msgKey={graph.title} />
            <span className="inline font-16">
              {" "}
              -{" "}
              <SafeFormattedMessage msgKey="DEFINITIONS" />
            </span>{" "}
            1
          </h1>
          <span className="coping-sub-title">
            <b>
              <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_SELF_TITLE" />
            </b>
          </span>
          <br />
          <table className="coping-table-fullwidth-less">
            <thead>
              <tr className="coping-table-header">
                <th>
                  <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_STRATEGY" />
                </th>
                <th className="th-2">
                  <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_EXPLANATION" />
                </th>
                <th className="th-3">
                  <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_STRENGTHS" />
                </th>
                <th className="th-4">
                  <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_LIMITS" />
                </th>
                <th className="th-7">
                  <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_NOTE" />
                </th>
              </tr>
            </thead>
            {/*first coping box */}
            <tbody>
              {copingSelfRows.map((row, i) => (
                <tr className="coping-table-row" key={i}>
                  <th className="th-1" style={isFrench || isEnglish ? { minWidth: '84px' } : undefined}>
                    <SafeFormattedMessage msgKey={row.strategy} />
                  </th>
                  <td>
                    <SafeFormattedMessage msgKey={row.explanation} />
                  </td>
                  <td>
                    <SafeFormattedMessage msgKey={row.strengths} />
                  </td>
                  <td>
                    <SafeFormattedMessage msgKey={row.limits} />
                  </td>
                  <td>
                    <SafeFormattedMessage
                      msgKey={getThirdPosition ? getThirdPosition(graph.data[row.noteIndex]) : ""}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

  { console.log(keyPage, "Locale in CopingDefinitionsPages:", locale) }
          {/* Show 'GERMAN' if the language is German */}
          {(locale && typeof locale === 'string' && (!locale.toLowerCase().startsWith('de') && !locale.toLowerCase().startsWith('fr'))) && (
            <div>
              <span className="coping-sub-title">
            <b>
              <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_COGNITIVE_TITLE" />
            </b>
          </span>
          <br />
          <table className="coping-table-fullwidth-less">
            <thead>
              <tr className="coping-table-header">
                <th>
                  <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_STRATEGY" />
                </th>
                <th className="th-2">
                  <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_EXPLANATION" />
                </th>
                <th className="th-3">
                  <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_STRENGTHS" />
                </th>
                <th className="th-4">
                  <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_LIMITS" />
                </th>
                <th className="th-7">
                  <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_NOTE" />
                </th>
              </tr>
            </thead>
            {/*second coping box */}
            <tbody>
              {copingCognitiveRows.map((row, i) => (
                <tr className="coping-table-row" key={i}>
                  <th>
                    <SafeFormattedMessage msgKey={row.strategy} />
                  </th>
                  <td>
                    <SafeFormattedMessage msgKey={row.explanation} />
                  </td>
                  <td>
                    <SafeFormattedMessage msgKey={row.strengths} />
                  </td>
                  <td>
                    <SafeFormattedMessage msgKey={row.limits} />
                  </td>
                  <td>
                    <SafeFormattedMessage
                      msgKey={getThirdPosition ? getThirdPosition(graph.data[row.noteIndex]) : ""}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
          )}

          
        </div>
        <div className="pdf-footer">
          <SafeFormattedMessage msgKey="PAGE" />{" "}
          {keyPage + 1}
          <div className="pdf-footer-separator">
            <b>
              <SafeFormattedMessage msgKey="CANDIDATE" />
            </b>
          </div>{" "}
          {code}
          <div className="pdf-footer-separator">
            <b>
              <SafeFormattedMessage msgKey="TEST_DATE" />
            </b>{" "}
            {datePassed}
          </div>
        </div>
      </div>
      {(locale && typeof locale === 'string' && (locale.toLowerCase().startsWith('de') || locale.toLowerCase().startsWith('fr'))) && (
      <div className="PageCharts-chart">
        <div className="header-logo-box">
          <img alt="ppe-logo" className="header-logo-img" src={ppeFullLogo} />
        </div>
        <div className="report-alt-page">
          <h1>
            <SafeFormattedMessage msgKey={graph.title} />
            <span className="inline font-16">
              {" "}
              -{" "}
              <SafeFormattedMessage msgKey="DEFINITIONS" />
            </span>{" "}
            2
          </h1>
            <div>
              <span className="coping-sub-title">
            <b>
              <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_COGNITIVE_TITLE" />
            </b>
          </span>
          <br />
          <table className="coping-table-fullwidth-less">
            <thead>
              <tr className="coping-table-header">
                <th>
                  <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_STRATEGY" />
                </th>
                <th className="th-2">
                  <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_EXPLANATION" />
                </th>
                <th className="th-3">
                  <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_STRENGTHS" />
                </th>
                <th className="th-4">
                  <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_LIMITS" />
                </th>
                <th className="th-7">
                  <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_NOTE" />
                </th>
              </tr>
            </thead>
            {/*second coping box */}
            <tbody>
              {copingCognitiveRows.map((row, i) => (
                <tr className="coping-table-row" key={i}>
                  <th>
                    <SafeFormattedMessage msgKey={row.strategy} />
                  </th>
                  <td>
                    <SafeFormattedMessage msgKey={row.explanation} />
                  </td>
                  <td>
                    <SafeFormattedMessage msgKey={row.strengths} />
                  </td>
                  <td>
                    <SafeFormattedMessage msgKey={row.limits} />
                  </td>
                  <td>
                    <SafeFormattedMessage
                      msgKey={getThirdPosition ? getThirdPosition(graph.data[row.noteIndex]) : ""}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>          
        </div>
        <div className="pdf-footer">
          <SafeFormattedMessage msgKey="PAGE" />{" "}
          {keyPage + 2}
          <div className="pdf-footer-separator">
            <b>
              <SafeFormattedMessage msgKey="CANDIDATE" />
            </b>
          </div>{" "}
          {code}
          <div className="pdf-footer-separator">
            <b>
              <SafeFormattedMessage msgKey="TEST_DATE" />
            </b>{" "}
            {datePassed}
          </div>
        </div>
      </div>
      )}
    </div>
  );
}